// extracted by mini-css-extract-plugin
export default {"payments":"Zd-z","header":"_d-z","adjustMarginAndPaddingNewDesign":"ae-z"};